import { createFileRoute } from "@tanstack/react-router";
import { SiteHeader } from "@/components/site-header";
import { Hero } from "@/components/hero";
import { SeasonalChapters } from "@/components/seasonal-chapters";
import { Collection } from "@/components/collection";
import { FieldNotesTeaser } from "@/components/field-notes-teaser";
import { ReleaseAccess } from "@/components/release-access";
import { Ritual } from "@/components/ritual";
import { SiteFooter } from "@/components/site-footer";
import { allPerfumesQueryOptions } from "@/lib/shopify-queries";
import heroImage from "@/assets/hero-archivist.jpg?format=webp&quality=72";

const SHARE_IMAGE = `https://houseofapocrypha.com${heroImage}`;

export const Route = createFileRoute("/")({
  // Prime the perfumes cache on the server so the Current Chapter grid
  // renders in the initial HTML (crawlable, no client-only loading state).
  loader: async ({ context }) => ({
    perfumes: await context.queryClient.ensureQueryData(allPerfumesQueryOptions).catch(() => []),
  }),
  head: () => ({
    meta: [
      { title: "House of Apocrypha — Natural Perfumes & Ritual" },
      {
        name: "description",
        content:
          "House of Apocrypha crafts natural perfumes rooted in story, ritual and alchemy — slow-made fragrances from rare botanicals, resins and absolutes.",
      },
      { property: "og:title", content: "House of Apocrypha — Natural Perfumes" },
      {
        property: "og:description",
        content: "Natural perfumes rooted in story, ritual and alchemy.",
      },
      { property: "og:url", content: "https://houseofapocrypha.com/" },
      { property: "og:image", content: SHARE_IMAGE },
      { property: "og:image:alt", content: "House of Apocrypha — natural perfumes of story, ritual and alchemy." },
      { name: "twitter:image", content: SHARE_IMAGE },
      { name: "twitter:title", content: "House of Apocrypha — Natural Perfumes" },
      { name: "twitter:description", content: "Natural perfumes rooted in story, ritual and alchemy." },
    ],
    links: [
      { rel: "canonical", href: "https://houseofapocrypha.com/" },
      { rel: "preload", as: "image", href: heroImage, fetchPriority: "high" },
    ],
  }),
  component: Index,
});

function Index() {
  const { perfumes } = Route.useLoaderData();

  return (
    <div className="min-h-screen bg-background reading-body">
      <SiteHeader />
      <main>
        <div className="section-fade-bottom">
          <Hero />
        </div>
        <div className="section-fade-bottom">
          <Collection initialPerfumes={perfumes} />
        </div>
        <div className="section-fade-bottom">
          <SeasonalChapters />
        </div>
        <div className="section-fade-bottom">
          <FieldNotesTeaser />
        </div>
        <div className="section-fade-bottom">
          <Ritual />
        </div>
        <ReleaseAccess />
      </main>
      <SiteFooter />
    </div>
  );
}


